export default __webpack_public_path__ + "static/media/a557c611665117179105a13f33881b2d1578670360119.7eba7c4f.webp";